<template>
    <div class="con-btn">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <div v-if="operate=='edit'">
                    <el-breadcrumb-item>编辑集成采购合同</el-breadcrumb-item>
                </div>
                <div v-else-if="operate=='chakan'">
                    <el-breadcrumb-item>查看集成采购合同同</el-breadcrumb-item>
                </div>
                <div v-else>
                    <el-breadcrumb-item>添加集成采购合同</el-breadcrumb-item>
                </div>
            </el-breadcrumb>
        </div>

        <swb-register-comn-contract :contractId="contractId" :operate="operate" :onlyView="onlyView" :contractType="contractType" :selectRealComId="selectRealComId" :merchant="merchant" ref="swb_register_comn_contract"></swb-register-comn-contract>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { syncSetBreadcrumb } from '../index'

    import SwbRegisterComnContract from './RegisterComnContract';
    Vue.regist(SwbRegisterComnContract);

    export default {
        name: 'swb-register-integ-purch-contract',
        path: '/register/integ/purch/contract',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        customBreadcrumb: true,
        desc: '编辑、查看、添加、集成采购合同',
        data: function () {
            return {
                contractType: 3,
                merchant: '服务商',
                contractId: null,
                operate: null,
                onlyView: null,
                selectRealComId: null,
            }
        },
        created: function () {
            let parentPath = null;
            let routeQuery = this.$getRouteQuery();
            this.operate = routeQuery.operate || null;
            if(Utils.isNoB(this.operate)) {
                this.operate = this.$route.query.operate || null;
            }
            if(this.operate == 'chakan') {
                let routeQuery = this.$getRouteQuery();
                this.contractId = routeQuery.contractId || null;
                this.onlyView = routeQuery.onlyView || null;
                this.selectRealComId = routeQuery.selectRealComId || null;
                parentPath = routeQuery.parentPath || null;
            } else {
                this.contractId = this.$route.query.contractId || null;
                this.onlyView = this.$route.query.onlyView || null;
                this.selectRealComId = this.$route.query.selectRealComId || null;
                parentPath = this.$route.query.parentPath || null;
            }
            if(this.operate == 'edit') {
                syncSetBreadcrumb("编辑集成采购合同", parentPath);
            } else if(this.operate == 'chakan') {
                syncSetBreadcrumb("查看集成采购合同", parentPath);
            } else {
                syncSetBreadcrumb("添加集成采购合同", parentPath);
            }
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/RegisterIntegPurchContract.vue